export default {
  namespaced: true,
  state: {
    isPinnacleSDKLoaded: false,
    isPinnacleMapShowing: false,
  },
  getters: {
    isPinnacleMapShowing: state => state.isPinnacleMapShowing,
    isPinnacleSDKLoaded: state => state.isPinnacleSDKLoaded
  },
  mutations: {
    setIsPinnacleMapShowing(state, value) {
      state.isPinnacleMapShowing = value;
    },
    setPinnacleSDKLoadedStatus(state, value) {
      state.isPinnacleSDKLoaded = value;
    }
  },
};